<template>
  <cal-dialog-shell persistent :loading="loading" :value="value" icon="mdi-briefcase-plus-outline" max-width="500" save-icon="mdi-plus"
                    save-text="Speichern" subtitle="Bezeichnung in allen drei Formen" title="Jobposition anlegen" tone="info"
                    @input="reset" @save="createJobType">
    <v-form ref="form" v-model="valid" lazy-validation>
      <section class="mdlg-section soft-inputs">
        <div class="mdlg-section__title"><v-icon small>mdi-briefcase-outline</v-icon>Bezeichnung</div>
        <div class="mdlg-field">
          <span class="acq-label">Geschlechtsneutrale Form <span class="mdlg-req">*</span></span>
          <v-text-field v-model="jobType.neutral" :rules="[RuleFactory.required()]" color="info" dense hide-details="auto" outlined/>
          <div class="acq-tiny">beispielsweise Rektor:in, Hausmeister:in</div>
        </div>
        <div class="mdlg-grid">
          <div class="mdlg-field">
            <span class="acq-label">Männliche Form <span class="mdlg-req">*</span></span>
            <v-text-field v-model="jobType.male" :rules="[RuleFactory.required()]" color="info" dense hide-details="auto" outlined/>
            <div class="acq-tiny">beispielsweise Rektor, Hausmeister</div>
          </div>
          <div class="mdlg-field">
            <span class="acq-label">Weibliche Form <span class="mdlg-req">*</span></span>
            <v-text-field v-model="jobType.female" :rules="[RuleFactory.required()]" color="info" dense hide-details="auto" outlined/>
            <div class="acq-tiny">beispielsweise Rektorin, Hausmeisterin</div>
          </div>
        </div>
      </section>
    </v-form>
  </cal-dialog-shell>
</template>

<script lang="ts">
import Vue from 'vue';
import CalDialogShell from '@/components/timetable2/dialogs/CalDialogShell.vue';
import { RuleFactory } from '@/helpers/ruleFactory.helper';
import { Form } from '@/interfaces/Form.interface';
import { JobType } from '@/interfaces/jobType.interface';
import { ResponsibleHandlerAPI } from '@/classes/api/responsible-handler.api.class';

export default Vue.extend({
  components: {CalDialogShell},
  data: () => ({
    loading: false,
    valid: true,
    jobType: {} as JobType,
  }),
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    RuleFactory: () => RuleFactory,
  },
  methods: {
    async createJobType() {
      const form = this.$refs.form as Form;
      if (form.validate()) {
        try {
          this.loading = true;
          const job = await ResponsibleHandlerAPI.jobTypes.create(this.jobType)
          this.valid = true;
          this.$emit('update:jobType', job);
          this.reset();
          this.$$showSnackbar('Jobposition erfolgreich angelegt.', 'success');
        } finally {
          this.loading = false;
        }
      }
    },
    reset() {
      this.jobType = {} as JobType;
      (this.$refs.form as Form | undefined)?.resetValidation();
      this.loading = false;
      this.$emit('input', false);
    },
  },
});
</script>
